import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from "@angular/common/http";
import { map } from "rxjs/operators";


const GEOLOCATION_ERRORS = {
    'errors.location.unsupportedBrowser': 'Browser does not support location services',
    'errors.location.permissionDenied': 'You have rejected access to your location',
    'errors.location.positionUnavailable': 'Unable to determine your location',
    'errors.location.timeout': 'Service timeout has been reached'
};

@Injectable({
    providedIn: 'root'
})

export class GeoLocationService {

    geoReverseService = 'https://nominatim.openstreetmap.org/reverse?key=iTzWSiYpGxDvhATNtSrqx5gDcnMOkntL&format=json&addressdetails=1&lat={lat}&lon={lon}';
    searchLink = 'https://nominatim.openstreetmap.org/search';

    constructor(public http: HttpClient) {
    }

    public getReverseGeo(lat, lng) {
        return new Observable(observer => {
            const params = (this.geoReverseService || '')
                .replace(new RegExp('{lon}', 'ig'), `${lng}`)
                .replace(new RegExp('{lat}', 'ig'), `${lat}`)
           
            // If the URL matches the one you want to ignore, complete the observable without emitting a value
            // Otherwise, proceed with the fetch request
            fetch(params)
                .then(response => response.json())
                .then(data => {
                    observer.next(data);
                    observer.complete();
                })
                .catch(error => observer.error(error));
        });
    }

    public getAddress(keyword) {

        const params = this.searchLink + `?q=${keyword || 'Norway'}&format=json`;
        return this.http.get(params, {headers: { 'Anonymous': 'byPass'}}).pipe(
            map(res => {
                return res;
            })
        );
    }

    public getLocation(geoLocationOptions?: any): Observable<any> {
        geoLocationOptions = geoLocationOptions || { timeout: 5000 };

        return Observable.create(observer => {

            if (window.navigator && window.navigator.geolocation) {
                window.navigator.geolocation.getCurrentPosition(
                    (position) => {
                        observer.next(position);
                        observer.complete();
                    },
                    (error) => {
                        switch (error.code) {
                            case 1:
                                observer.next(GEOLOCATION_ERRORS['errors.location.permissionDenied']);
                                observer.complete();
                                break;
                            case 2:
                                observer.next(GEOLOCATION_ERRORS['errors.location.positionUnavailable']);
                                observer.complete();
                                break;
                            case 3:
                                observer.next(GEOLOCATION_ERRORS['errors.location.timeout']);
                                observer.complete();
                                break;
                        }
                    },
                    geoLocationOptions);
            } else {
                observer.next(GEOLOCATION_ERRORS['errors.location.unsupportedBrowser']);
                observer.complete();
            }

        });
    }
}

export let geolocationServiceInjectables: Array<any> = [
    {provide: GeoLocationService, useClass: GeoLocationService }
];
